import config from "../../config";
const baseUrl = config.baseUrl;

export const CityUrls = {

  CITY_ADD: baseUrl + "/city",
  CITY_EDIT: baseUrl + "/city",
  CITY_STATUS: baseUrl + "/city/changedStatus",
  CITY_LIST: baseUrl + "/city",
  CITY_DELETE: baseUrl + "/city",
  CITY_GETBYID: baseUrl + "/city",
  CITY_DROPDOWN: baseUrl + "/city/dropdown?export=true",
  CITY_ROLLBACK: baseUrl + "/city/rollback",
  CITY_DELETE_HARD: baseUrl + "/city",
};